
import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

const utils = {
  getData(el, key) {
    return el.dataset[key];
  }
};

/* -------------------------------------------------------------------------- */
/*                                  Flatpickr                                 */
/* -------------------------------------------------------------------------- */
var defaultPredefinedRanges = [{
  id: 'today',
  label: 'Today',
  range: [new Date(new Date().setHours(0, 0, 0, 0)), new Date()]
}, {
  id: 'yesterday',
  label: 'Yesterday',
  range: [new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999))]
}, {
  id: 'last_7_days',
  label: 'Last 7 Days',
  range: [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date()]
}, {
  id: 'last_30_days',
  label: 'Last 30 Days',
  range: [new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000), new Date()]
}, {
  id: 'last_90_days',
  label: 'Last 90 Days',
  range: [new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000), new Date()]
}
];
function applyUserRange(defaultRange, userRange) {
  var matchingDefault = defaultRange.find(function (mathItem) {
    return mathItem.id === Object.keys(userRange)[0];
  });
  return matchingDefault ? {
    ...matchingDefault,
    label: userRange[Object.keys(userRange)[0]]
  } : userRange;
}
function findDefaultRange(defaultRange, userRange) {
  return defaultRange.find(function (rangeItem) {
    return rangeItem.id === userRange;
  }) || null;
}
function generateRangeButtons(predefinedDefaultRanges) {
  var userDefinedRanges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var normalizedUserRanges = Array.isArray(userDefinedRanges) ? userDefinedRanges : predefinedDefaultRanges;
  var mergedRanges = normalizedUserRanges.map(function (userRange) {
    if (typeof(userRange) === 'object') {
      return applyUserRange(predefinedDefaultRanges, userRange);
    }
    return findDefaultRange(predefinedDefaultRanges, userRange);
  }).filter(Boolean);
  return "\n      <ul class=\"flatpickr-predefined-ranges list-group list-group-flush\">\n        ".concat(mergedRanges.map(function (_ref3) {
    var range = _ref3.range,
      label = _ref3.label;
    return "\n            <button type=\"button\" \n              data-range=\"".concat(range.map(function (date) {
      return date instanceof Date ? date.toISOString() : date;
    }).join(','), "\" \n              class=\"nav-link list-group-item list-group-item-action\">\n              ").concat(label, "\n            </button>\n          ");
  }).join(''), "\n      </ul>\n    ");
}
function appendRangeButtonsIfNotExists(calendarContainer, rangeButtonsHtml) {
  if (!calendarContainer.querySelector('.flatpickr-predefined-ranges')) {
    calendarContainer.insertAdjacentHTML('afterbegin', rangeButtonsHtml);

    // need to move .flatpickr-months under .flatpickr-innerContainer
    const innerContainer = document.querySelector('.flatpickr-innerContainer');
    const months = document.querySelector('.flatpickr-months');
    if (innerContainer && months) {
      innerContainer.insertBefore(months, innerContainer.firstChild);
    }
  }
}
function addRangeButtonClickListeners(instance, calendarContainer) {
  [...calendarContainer.querySelectorAll('[data-range]')].map(function (btn) {
    return btn.addEventListener('click', function () {
      var startDate = new Date(utils.getData(btn, 'range').split(',')[0]);
      var endDate = new Date(utils.getData(btn, 'range').split(',')[1]);
      instance.setDate([startDate, endDate], true);
      instance.redraw();
      instance.close();
    });
  });
}
function initializeFlatpickr(element, options) {
  function showPredefinedRanges(selectedDates, dateStr, instance) {
    var calendarContainer = instance.calendarContainer;
    console.log("initializeFlatpkr")
    if (options.predefinedRanges) {
    console.log("predefined ranges")
      calendarContainer.classList.add('predefinedRange');
      var rangeButtonsHtml = generateRangeButtons(defaultPredefinedRanges, options.predefinedRanges);
      appendRangeButtonsIfNotExists(calendarContainer, rangeButtonsHtml);
      addRangeButtonClickListeners(instance, calendarContainer);
    }
  }
  function hidePredefinedRanges(selectedDates, dateStr, instance) {
    if (options.predefinedRanges) {
      var calendarContainer = instance.calendarContainer;
      calendarContainer.classList.remove('predefinedRange');
    }
  }
  var instance = flatpickr(element, {
    ...options,
    onOpen: showPredefinedRanges,
    onClose: hidePredefinedRanges,
    mode: "range",
    allowInput: true,
    dateFormat: "m/d/Y",
    locale: {
      rangeSeparator: " - "  // use dash instead of " to "
    }
  });
  return instance;
}
export default class extends Controller {
  static targets = ["input"];
  connect() {
    console.log("date-range-search connection()")
    const el = this.inputTarget;

    console.log("initializing")
    if (el.dataset.pickerInitialized) return

    flatpickr(el, {
      mode: "range",
      dateFormat: "m/d/Y",
      allowInput: true,
      locale: {
        rangeSeparator: " - "  // use dash instead of " to "
      }
    })

    el.dataset.pickerInitialized = "true"
    initializeFlatpickr(el, { predefinedRanges: true});

  }
}


